module.exports = __webpack_public_path__ + "content/bfee80116f994fd5b71508b61840190a.png";